export type MapActionOption = {
  id: string;
  label: string;
  onPress: () => void;
};

type MapDestination = {
  title: string;
  address: string;
  latitude?: number;
  longitude?: number;
};

type PhoneDestination = {
  phone: string;
  placeName?: string;
};

function openExternalUrl(url: string) {
  window.open(url, "_blank", "noopener,noreferrer");
}

function sanitizePhoneDigits(phone: string) {
  return phone.replace(/\D/g, "");
}

function buildMapUrls({ address, latitude, longitude }: MapDestination) {
  const addressQuery = encodeURIComponent(address);

  if (latitude != null && longitude != null) {
    return {
      googleMaps: `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`,
      waze: `https://waze.com/ul?ll=${latitude},${longitude}&navigate=yes`,
      fallback: `https://www.google.com/maps/search/?api=1&query=${addressQuery}`,
    };
  }

  return {
    googleMaps: `https://www.google.com/maps/search/?api=1&query=${addressQuery}`,
    waze: `https://waze.com/ul?q=${addressQuery}&navigate=yes`,
    fallback: `https://www.google.com/maps/search/?api=1&query=${addressQuery}`,
  };
}

export function getMapAppActions(
  destination: MapDestination
): MapActionOption[] {
  const urls = buildMapUrls(destination);

  return [
    {
      id: "google-maps",
      label: "Google Maps",
      onPress: () => openExternalUrl(urls.googleMaps),
    },
    {
      id: "waze",
      label: "Waze",
      onPress: () => openExternalUrl(urls.waze),
    },
  ];
}

export function getPhoneContactActions({
  phone,
  placeName,
}: PhoneDestination): MapActionOption[] {
  const digits = sanitizePhoneDigits(phone);
  const whatsappMessage = encodeURIComponent(
    placeName
      ? `Olá, gostaria de mais informações sobre ${placeName}.`
      : "Olá, gostaria de mais informações sobre este local."
  );

  return [
    {
      id: "call",
      label: "Ligar",
      onPress: () => {
        window.location.href = `tel:${digits}`;
      },
    },
    {
      id: "whatsapp",
      label: "WhatsApp",
      onPress: () =>
        openExternalUrl(
          `https://api.whatsapp.com/send?phone=55${digits}&text=${whatsappMessage}`
        ),
    },
  ];
}
